// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nowrap[data-v-0da4d8d0] {\n  white-space: nowrap;\n}\n.table-scroll[data-v-0da4d8d0] {\n  overflow-x: auto;\n}\n", ""]);
// Exports
module.exports = exports;
